import * as React from "react"
// import { Link } from "gatsby"
// import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import favi from "../images/favi.png"
import fsCover from "../images/fs.png"
import fsCover2 from "../images/fs2.png"
import fsCover3 from "../images/fs3.png"
import fsCover4 from "../images/fs4.png"
// import * as styles from "../components/index.module.css" // Already removed

// Remove unused constants: links, samplePageLinks, moreLinks, utmParameters
/*
const links = [
  // ... content omitted ...
]

const samplePageLinks = [
  // ... content omitted ...
]

const moreLinks = [
  // ... content omitted ...
]

const utmParameters = `?utm_source=starter&utm_medium=start-page&utm_campaign=default-starter`
*/

const IndexPage = () => (
  <Layout>
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      height: '100%'
    }}>
      <h1 style={{ 
        marginBottom: '1rem', 
        fontSize: '2.5rem', 
        fontWeight: 'bold', 
        color: '#FFFFFF', 
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)'
      }}>
        The new Fish Sniffer is coming soon.
      </h1>
      <p style={{ 
        marginBottom: '1.5rem', 
        fontSize: '1.2rem', 
        color: '#FFFFFF',
        textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)' 
      }}>
        In the meantime, check out the{' '}
        <a 
          href="https://magazine.fishsniffer.com/"
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ textDecoration: 'none', textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)' }}
          onMouseOver={(e) => e.target.style.textDecoration='underline'}
          onFocus={(e) => e.target.style.textDecoration='underline'}
          onMouseOut={(e) => e.target.style.textDecoration='none'}
          onBlur={(e) => e.target.style.textDecoration='none'}
        >
          latest issue
        </a>.
      </p>
      <div className="cover-grid">
        {[
          { src: fsCover, label: 'Volume 44, Issue 04 (April 25th, 2025)', link: 'https://magazine.fishsniffer.com/fish-sniffer-magazine-volume-44-issue-04/0179852001745562714' },
          { src: fsCover2, label: 'Volume 44, Issue 03 (March 28th, 2025)', link: 'https://magazine.fishsniffer.com/fish-sniffer-magazine-volume-44-issue-03/0728704001743177121' },
          { src: fsCover3, label: 'Volume 44, Issue 02 (February 28th, 2025)', link: 'https://magazine.fishsniffer.com/fish-sniffer-magazine-volume-44-issue-02/0322271001740846635' },
          { src: fsCover4, label: 'Volume 44, Issue 01 (January 10th, 2025)', link: 'https://magazine.fishsniffer.com/fish-sniffer-magazine-volume-44-issue-01/0926803001736492027' }
        ].map(({ src, label, link }, idx) => (
          <div key={idx} className="cover-item" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <img
                src={src}
                alt={label}
                style={{
                  width: '100%',
                  transform: 'perspective(600px) rotateY(-20deg) scale(1)',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.5)',
                  transformStyle: 'preserve-3d',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseMove={e => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = e.clientX - rect.left - rect.width/2;
                    const y = rect.height/2 - (e.clientY - rect.top);
                    const rotY = (x/rect.width)*10;
                    const rotX = (y/rect.height)*10;
                    e.currentTarget.style.transform = `perspective(600px) rotateX(${rotX}deg) rotateY(${rotY}deg) scale(1.05)`;
                    e.currentTarget.style.boxShadow = '0 20px 30px rgba(0,0,0,0.7)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.transform = 'perspective(600px) rotateY(-20deg) scale(1)';
                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.5)';
                }}
              />
              <div style={{ marginTop: '0.5rem', color: '#FFFFFF', fontWeight: 'bold' }}>{label}</div>
            </a>
          </div>
        ))}
      </div>
    </div>
  </Layout>
)

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => (
  <>
    <title>The Fish Sniffer | The Magazine for West Coast Sportsmen</title>
    <link rel="icon" href={favi} />
  </>
)

export default IndexPage
